













































import { Component, Vue, Prop } from "vue-property-decorator";
import { parseZhinengwuzangResult } from "@/utils/parseZhinengwuzang";

const SPECIAL_REPORTS = ["四诊合参体质辨识", "智能中医五脏测评"];

@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;

  private formatResult(row: any): string {
    if (!SPECIAL_REPORTS.includes(row["报告名称"])) {
      return row["评估结果"] || "";
    }
    const result = row["评估结果"] || row["中医辨证结果"];
    if (!result) {
      return "";
    }
    const parsed = parseZhinengwuzangResult(result);
    if (parsed?.constitutionText) {
      return parsed.constitutionText;
    }
    return parsed?.mainConstitution || result;
  }

  private goDetail(item: any) {
    this.$emit("jumpDetail", item);
  }
}
